// PI1 Form Validation:
// * Loan Amount min/max by Provider Products offered
// * these min / max values determine boundary of loans offered
import { staticConstants as constants } from "../../../constants-ui";
import _isEmpty from "lodash.isempty";
import {
  isntEmpty,
  isNum,
  isNumGreaterThan,
  isNumLessThan,
} from "./pi1-form-validation";

// USEFUL NOTES
// NI = No Interest; TNI; PNI; ADS Bank
// PRP = Promotional Rate Plan; ADS Bank
// IL = Installment Loan; Fixed Rate Plan; Extended Plans; NBT Bank
// LCTNI = Lending Club true No Interests; LCBank
// LCFRP = Lending Club Fixed Rate Plan; LCBank
// expects API response of Product List
// by Client ID, with 'products' prop
// return product types offered
// - with min max loan amounts determined by hard code values (not API res min,max vals)
// pf-common ?
export const determineLoanTypes = (productList) => {
  let planList = [];

  let providerProducts = {
    minGeneralAmount: null,
    maxGeneralAmount: null,
    MAMinAmount: constants.MA_min_amount.value,
  };

  if (productList?.length) {
    planList = productList;
  }

  const isClientOfferingADS = planList.some(
    ({ productType }) =>
      productType === "PROMOTIONAL_RATE_PLAN" ||
      productType === "INTEREST_FREE_LOAN",
  );
  if (!isClientOfferingADS) {
    providerProducts.useMinAmountForMA = true;
  }

  // init product state based on product response
  planList.forEach((plan) => {
    const planModel = {
      minAmount: parseInt(plan.minimumAmount.split(".")[0], 10),
      maxAmount: parseInt(plan.maximumAmount.split(".")[0], 10),
    };
    providerProducts[plan.productType] = planModel;
  });

  // PI1 form initial defaultProps use this path
  if (planList === undefined || planList.length === 0) {
    return providerProducts;
  }
  // loop through actual products available from provider (via API)
  // any product present in the loop will, set 'offers' to TRUE (previously set FALSE)
  // - also it's presence will potentially influence global min/max value
  planList.forEach(({ minimumAmount, maximumAmount }) => {
    minimumAmount = parseInt(minimumAmount.split(".")[0], 10);
    maximumAmount = parseInt(maximumAmount.split(".")[0], 10);
    const nextMin = minimumAmount;
    const nextMax = maximumAmount;
    const { minGeneralAmount, maxGeneralAmount } = providerProducts;
    providerProducts.minGeneralAmount =
      !minGeneralAmount || nextMin < minGeneralAmount
        ? nextMin
        : minGeneralAmount;
    providerProducts.maxGeneralAmount =
      nextMax > maxGeneralAmount ? nextMax : maxGeneralAmount;
  });
  return providerProducts;
};

export const setLoanStr = (min, max) => {
  const { str: minStr } = min,
    { str: maxStr } = max,
    baseStr1 = "Please enter an amount between",
    baseStr2 = "and";
  return `${baseStr1} ${minStr} ${baseStr2} ${maxStr}`;
};

export const setLoanValidation = (loanTypes = {}) => {
  // clientId = '230761', 'IL-PRP', 'IL-NI', 'IL-ONLY'
  const fallBackMin = 1000,
    fallBackMax = 65000;
  // { min: fallBackMinMA, max: fallBackMaxMA } = defaultLoanType.lnAmounts.MA;  // TODO incorporate MA
  let min, max, minToUse, maxToUse, msgStr;

  if (!_isEmpty(loanTypes) && loanTypes.min && loanTypes.max) {
    min = loanTypes.min;
    max = loanTypes.max;
  }

  // deal with happy path or unhappy path
  minToUse = _isEmpty(min) || min === undefined ? fallBackMin : min;
  maxToUse = _isEmpty(max) || max === undefined ? fallBackMax : max;
  msgStr = setLoanStr(minToUse, maxToUse);

  let rule1 = {
      chk: isntEmpty,
      msg: msgStr,
    },
    rule2 = {
      chk: isNum,
      msg: msgStr,
    },
    rule3 = {
      chk: isNumGreaterThan,
      msg: msgStr,
      cond: minToUse.cond,
    },
    rule4 = {
      chk: isNumLessThan,
      msg: msgStr,
      cond: maxToUse.cond,
    },
    ruleset = [rule1, rule2, rule3, rule4];

  return ruleset;
};

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');